// NotFound (404) page strings (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'notfound.head': 'Not found',
  'notfound.title': "We couldn't find that",
  'notfound.body':
    "The page or record you're looking for doesn't exist, has moved, or isn't available to you.",
  'notfound.back': 'Go back',
  'notfound.home': 'Dashboard',
}

export const zhTW = {
  'notfound.head': '找不到頁面',
  'notfound.title': '找不到您要的內容',
  'notfound.body': '您尋找的頁面或資料不存在、已移動，或您無權存取。',
  'notfound.back': '返回',
  'notfound.home': '儀表板',
}
